import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {Activity, Affirmation, ChildrenAffirmation, ReportAffirmation, StudentClass} from '../../../models/applicationFeature';
import {AffirmationService} from '../../../services/affirmation.service';
import {CommonService} from '../../../services/common.service';
import {ReportService} from '../../../services/report.service';
import {StudentClassService} from '../../../services/student-class.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import {GeneralEmailComponent} from '../../dialogs/general-email/general-email.component';

@Component({
    selector: 'app-college-enrollments',
    templateUrl: './college-enrollments.component.html',
    styleUrls: ['./college-enrollments.component.scss']
})
export class CollegeEnrollmentsComponent implements OnInit {
    activities: Activity[];
    isLoading: boolean;
    childrenEnrollments: ChildrenAffirmation[];
    affirmations: Affirmation[];
    reportAffirmations: ReportAffirmation[] = [];
    studentClasses: StudentClass[] = [];
    reports: any[] = [];
    originalReports: any[] = [];
    distinctReports: any[] = [];

    constructor(public commonService: CommonService,
                public affirmationService: AffirmationService,
                private studentClassService: StudentClassService,
                public dialog: MatDialog,
                public router: Router,
                private reportService: ReportService,
                public toastMessagesService: ToastMessagesService) {
        this.isLoading = false;
    }

    async ngOnInit() {
        this.isLoading = true;
        // this.studentClasses = await this.studentClassService.initClasses();
        // this.childrenEnrollments = await this.affirmationService.initChildrenAffirmations();
        // this.reportAffirmations = await this.affirmationService.initReportAffirmations(this.studentClasses, this.childrenEnrollments);
        // await this.initReports();
        await this.initializeReports();
        this.isLoading = false;
    }


    async initializeReports() {
        this.isLoading = true;
        const tempReports = [];

        try {
            const reportsRequest = await this.reportService.getCustomAffirmationsReport();

            const reports = reportsRequest;
            for (const report of reports) {
                for (const question of report.questions) {
                    const model = {
                        created: report.created,
                        modified: report.modified,
                        uniqueId: report.uniqueId,
                        formTitle: report.title,
                        activityDescription: question.title,
                        sum: question.accepted.length + question.denied.length + question.pending.length,
                        accepted: question.accepted.length,
                        acceptedInfo: question.accepted,
                        declined: question.denied.length,
                        declinedInfo: question.denied,
                        notAnswered: question.pending.length,
                        pendingInfo: question.pending
                    };
                    tempReports.push(model);
                }
            }
            console.log(reports);
            this.reports = tempReports;
            this.originalReports = JSON.parse(JSON.stringify(tempReports));
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        } finally {
            this.isLoading = false;
        }
    }

    // async initReports() {
    //     try {
    //         const reportQuery = await this.commonService.getList(`reports/affirmation/children`);
    //         this.reports = reportQuery.object;
    //         // tslint:disable-next-line:variable-name
    //         this.distinctReports = Array.from(new Set(this.reports.map(report => report.form_unique_id))).map(form_unique_id => {
    //             return this.reports.find(r => r.form_unique_id === form_unique_id);
    //         });
    //     } catch (e) {
    //         this.toastMessagesService.toastErrorMessage(e.message);
    //     }
    // }

    calculate(num: number, sum: number) {
        const result = (num / sum) * 100;
        const percentage = Math.round(result);

        if (percentage === 0) {
            return `(${percentage}%)`;
        } else {
            return `${num}/${sum} (${percentage}%)`;
        }
    }


    async navigateToDetails(reportAffirmation: any) {
        // const inputConfig = {
        //     id: reportAffirmation.form_unique_id
        // };
        // await this.router.navigate(['home/affirmation-report-details'], {queryParams: inputConfig});
        localStorage.setItem('latestReport', JSON.stringify(reportAffirmation));
        // const inputConfig = {
        //     id: report.unique_id,
        //     question: report.id
        // };
        // await this.router.navigate(['home/report-details'], {queryParams: inputConfig});
        await this.router.navigate(['home/report-details']);
    }

    showClasses(affirmation: Affirmation) {
        if (affirmation.classRestrictions && affirmation.classRestrictions !== 'null') {
            const restrictions = JSON.parse(affirmation.classRestrictions);
            return restrictions.map(e => e.description).join(',');
        } else {
            return 'Όλες';
        }
    }

    getStatusDisplayText(affirmation: Affirmation) {
        return affirmation.is_published === 1 ? 'Δημοσιευμένη' : affirmation.is_published === -1 ? 'Έληξε' : 'Μη Δημοσιευμένη';
    }

    notifyUsers(reportAffirmation: any) {

        const emails = {accepted: reportAffirmation.acceptedInfo, denied: reportAffirmation.declinedInfo, pending: reportAffirmation.pendingInfo};
        try {
            this.dialog.open(GeneralEmailComponent, {
                height: '100vh',
                // panelClass: 'full-screen-modal',
                data: {
                    mode: 1,
                    emails
                }
            });
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    // tslint:disable-next-line:variable-name
    calculateCompleted(form: any) {
        const totalSent = form.sum;
        const completed = form.accepted;
        const result = (completed / totalSent) * 100;
        const percentage = Math.round(result);

        if (percentage === 0) {
            return `(${percentage}%)`;
        } else {
            return `${completed}/${totalSent} (${percentage}%)`;
        }
    }

    // tslint:disable-next-line:variable-name
    calculateCanceled(form: any) {

        const totalSent = form.sum;
        const completed = form.declined;
        const result = (completed / totalSent) * 100;
        const percentage = Math.round(result);

        if (percentage === 0) {
            return `(${percentage}%)`;
        } else {
            return `${completed}/${totalSent} (${percentage}%)`;
        }
    }

    // tslint:disable-next-line:variable-name
    calculatePending(form: any) {
        const totalSent = form.sum;
        const completed = form.notAnswered;
        const result = (completed / totalSent) * 100;
        const percentage = Math.round(result);

        if (percentage === 0) {
            return `(${percentage}%)`;
        } else {
            return `${completed}/${totalSent} (${percentage}%)`;
        }
    }
}

